let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("iHplQ")), load("9r5vw")]).then(() => parcelRequire('kR6P1'));